import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import style from './Aside.module.scss'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

const Aside = () => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  return (
    <>
      {!viewport.mobile && (
        <aside className={style.aside}>
          <div className={style.pickup}>
            <span className={style.text}>{t('questions', 'ec', 'nike', 'pickupToday')}</span>
            <EmptyLink color="#111">
              <div className={style.toggler} />
            </EmptyLink>
          </div>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'gender')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'kids')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'kidsAge')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'saleOffers')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'color')}</div>

              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'shopByPrice')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'sports')}</div>

              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'benefits')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'bestFor')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'brand')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'width')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
          <EmptyLink color="#111">
            <div className={style.asideItem}>
              <div className={style.asideText}>{t('questions', 'ec', 'nike', 'shoes')}</div>
              <i className="pi pi-angle-down" />
            </div>
          </EmptyLink>
        </aside>
      )}
    </>
  )
}
export default Aside
